import PropTypes from 'prop-types';
import React from 'react';
import Favicon from 'react-favicon';

import { SYSTEM_RESOURCE } from '../../constants/EndPoints';
import * as misc from '../../constants/Misc';

import { connect } from 'react-redux';

import LinearProgress from '@material-ui/core/LinearProgress';

import ResetPassword from '../../components/Login/ResetPasswrd';
import SignIn from '../../components/Login/SignIn';
import VerifyNewPassword from '../../components/Login/VerifyNewPassword';

import AuthenticateMfaCode from '../../components/Login/AuthenticateMfaCode';
import ChooseMfaFactor from '../../components/Login/ChooseMfaFactor';
import MfaEnrollmentWizard from '../../components/Login/MfaEnrollment/MfaEnrollmentWizard';
import { completeMfaEnrollment } from '../../actions/LoginActions';
import { getMfaResolver } from '../../services/authFirebase';
import './Login.scss';

// Import the auth service or module here
import auth from '../../services/appAuth'; // Ensure this path is correct

const NEED_MFA_ERROR = 'auth/multi-factor-auth-required';
const FIREBASE_MFA_CODE = 'FIREBASE_MFA_CODE';
const FIREBASE_MFA_CHOOSE_FACTOR = 'FIREBASE_MFA_CHOOSE_FACTOR';

const systemName = process.env.REACT_APP_SYSTEM_NAME;

function CLogin(props, context) {
  const [mode, setMode] = React.useState('signIn');
  const [additionalData, setAdditionalData] = React.useState(null);
  const [isLoading, setLoading] = React.useState(false);
  const [user, setUser] = React.useState();

  const sys = SYSTEM_RESOURCE;

  // Dynamically construct the background image path
  const backgroundImagePath = require(`../../../images/system/${sys}/login_bg.png`);

  const mainStyle = {
    backgroundImage: `url(${backgroundImagePath})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  function changeMode(newMode, additional) {
    setMode(newMode);
    if (additional) {
      setAdditionalData(additional);
    }
  }

  function handleAuthCode(code, errCallback) {
    if (!user) {
      console.log('NO USER!!');
    } else {
      props.verifyMfaCode(user, code, errCallback);
    }
  }

  const handleFireBaseAuthCode = async (code, errCallback) => {
    try {
      await props.finishMfa(code, errCallback);
      // If MFA verification succeeds, proceed with the next steps
    } catch (error) {
      // If an error occurs, check if it's due to wrong MFA code
      if (error.message === 'Wrong MFA code.') {
        // Handle the case where the user enters the wrong MFA code
        console.error('Wrong MFA code.');
        // Call the error callback to handle the UI update or display error message
        if (typeof errCallback === 'function') {
          errCallback(error.message);
        }
      } else {
        // Handle other errors
        console.error(error);
      }
    }
  };

  return (
    <section className='page login-page'>
      <Favicon url={require(`./../../../images/system/${sys}/favicon_1.png`)} />

      <div className='main' style={mainStyle}>
        <div className='login-form form-horizontal'>
          <header>
            <div className='logo'>{systemName}</div>
            <div className='version'>
              {context.t('ver')}. <strong>{misc.versionNumber}</strong>
            </div>
          </header>

          {isLoading && <LinearProgress style={{ position: 'sticky' }} />}

          {props.mfaEnrollmentRequired ? (
            <MfaEnrollmentWizard
              details={props.mfaEnrollmentDetails}
              onComplete={props.completeMfaEnrollment}
              onCancel={props.cancelMfaEnrollment}
              context={context}
            />
          ) : (
            <React.Fragment>
              {mode === 'signIn' && (
                <SignIn
                  signInFunc={props.signIn}
                  changeLoginMode={changeMode}
                  loading={isLoading}
                  setLoading={setLoading}
                  setLoggingInUser={setUser}
                  signInSSO={props.signInSSO}
                />
              )}

              {mode === 'resetPassword' && (
                <ResetPassword
                  backTo={changeMode}
                  loading={isLoading}
                  setLoading={setLoading}
                  signInFunc={props.signIn}
                />
              )}

              {mode === 'setMfaCode' && (
                <AuthenticateMfaCode
                  signInFunc={handleAuthCode}
                  setLoading={setLoading}
                  backTo={changeMode}
                  context={context}
                />
              )}
              {mode === 'setFirebaseMfaCode' && (
                <AuthenticateMfaCode
                  signInFunc={handleFireBaseAuthCode}
                  setLoading={setLoading}
                  backTo={changeMode}
                  context={context}
                />
              )}

              {mode === 'chooseMfaFactor' && (
                <ChooseMfaFactor
                  hints={(additionalData && additionalData.hints) || []}
                  onSelect={(hint, errCallback) => {
                    setLoading(true);
                    props.startFactorChallenge(
                      hint,
                      additionalData.session,
                      (error) => {
                        setLoading(false);
                        if (error) {
                          errCallback(error);
                        } else {
                          changeMode('setFirebaseMfaCode');
                        }
                      }
                    );
                  }}
                  backTo={changeMode}
                  context={context}
                />
              )}

              {mode === 'newPasswordRequired' && (
                <VerifyNewPassword
                  loginData={additionalData}
                  changeNewPassword={props.changeNewPassword}
                  setLoading={setLoading}
                />
              )}
            </React.Fragment>
          )}

          {JSON.parse(process.env.REACT_APP_SHOW_LOGIN_FOOTER) &&
            mode === 'signIn' && (
              <footer className='form-group'>
                <div className='control-label' style={{ textAlign: 'center' }}>
                  <span>{context.t('by_clicking_login_you_agree_to_our')}</span>
                  <a
                    style={{ marginLeft: '5px', marginRight: '5px' }}
                    href={`${process.env.PUBLIC_URL}/certificates/Terms_and_Conditons.pdf`}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {context.t('terms_and_conditions')}
                  </a>
                  <span>{context.t('and_our')}</span>
                  <a
                    style={{ marginLeft: '5px' }}
                    href={`${process.env.PUBLIC_URL}/certificates/Privacy_Policy.pdf`}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {context.t('privecy_policy')}
                  </a>
                </div>
              </footer>
            )}
        </div>
      </div>
    </section>
  );
}

CLogin.contextTypes = {
  t: PropTypes.func.isRequired,
};

CLogin.propTypes = {
  changeNewPassword: PropTypes.func.isRequired,
  signIn: PropTypes.func.isRequired,
  verifyMfaCode: PropTypes.func.isRequired,
};

/*
 *
 */
function mapDispatchToProps(dispatch, props) {
  return {
    ...props,
    signInSSO: (providerId) => {
      return auth.signInWithOkta(providerId);
    },
    signIn: (email, password, callback) => {
      auth
        .signInWithEmailAndPassword(email, password)
        .then((data) => {
          callback(data);
        })
        .catch(async (error) => {
          if (error.code === NEED_MFA_ERROR) {
            try {
              const resolver = getMfaResolver(error);
              if (resolver.hints.length > 1) {
                callback({
                  challengeName: FIREBASE_MFA_CHOOSE_FACTOR,
                  hints: resolver.hints,
                  session: resolver.session,
                });
              } else {
                await auth.startMfaSignin(resolver.hints[0], resolver.session);
                callback({ challengeName: FIREBASE_MFA_CODE });
              }
            } catch (mfaError) {
              console.error(mfaError);
              callback(new Error(mfaError.message));
            }
            return;
          }
          const err = new Error(error.message);
          callback(err);
        });
    },
    startFactorChallenge: async (hint, session, callback) => {
      try {
        await auth.startMfaSignin(hint, session);
        callback(null);
      } catch (error) {
        console.error(error);
        callback(error);
      }
    },
    completeMfaEnrollment: () => {
      dispatch(completeMfaEnrollment());
    },
    cancelMfaEnrollment: () => {
      auth.signOut();
    },
    finishMfa: async (code, errCallback) => {
      try {
        await auth.finishMfaSignIn(code);
      } catch (error) {
        errCallback(error);
        console.log(error);
      }
    },

    changeNewPassword: (email, password, newPassword, callback) => {
      auth
        .loginSetNewPassword(email, password, newPassword)
        .then((data) => {
          // console.log(data);
        })
        .catch((error) => {
          const err = new Error(error.message);
          callback(err);
        });
    },

    verifyMfaCode: (user, code, errCallback) => {
      auth
        .verifySmsMfaCode(user, code)
        .then((data) => {
          console.log(data);
        })
        .catch((err) => {
          errCallback(err);
        });
    },
  };
}

function mapStateToProps(state) {
  return {
    mfaEnrollmentRequired: state.user.mfaEnrollmentRequired,
    mfaEnrollmentDetails: state.user.mfaEnrollmentDetails,
  };
}

const cLogin = connect(mapStateToProps, mapDispatchToProps)(CLogin);

export default cLogin;
